export const raceCardHorsesMockData = [
    {
        name: '1 PILOTHOUSE',
        DOB: '3 g b - DOB: 16 Nov 2015',
        breeder: 'Sail From Seattle - Pacific Peace by Dynaformer Breeder: Moutonshoek',
        weight: '60kg',
        jockeySilks: 'R1-10'
    },
    {
        name: '2 WINTERS WAYS',
        DOB: '5 ch g - DOB: 01.10.2013',
        breeder: 'HORSE CHESTNUT - Fenella ( Kitalpha ) Breeder: ALDORA STUD',
        weight: '60kg',
        jockeySilks: 'R1-12'
    },
    {
        name: '3 PILOTHOUSE',
        DOB: '3 g b - DOB: 16 Nov 2015',
        breeder: 'Sail From Seattle - Pacific Peace by Dynaformer Breeder: Moutonshoek',
        weight: '60kg',
        jockeySilks: 'R1-8'
    },
    {
        name: '4 WINTERS WAYS',
        DOB: '5 ch g - DOB: 01.10.2013',
        breeder: 'HORSE CHESTNUT - Fenella ( Kitalpha ) Breeder: ALDORA STUD',
        weight: '60kg',
        jockeySilks: 'R1-9'
    },
    {
        name: '5 PILOTHOUSE',
        DOB: '3 g b - DOB: 16 Nov 2015',
        breeder: 'Sail From Seattle - Pacific Peace by Dynaformer Breeder: Moutonshoek',
        weight: '60kg',
        jockeySilks: 'R1-3'
    },
    {
        name: '6 WINTERS WAYS',
        DOB: '5 ch g - DOB: 01.10.2013',
        breeder: 'HORSE CHESTNUT - Fenella ( Kitalpha ) Breeder: ALDORA STUD',
        weight: '60kg',
        jockeySilks: 'R1-12'
    },
    {
        name: '7 PILOTHOUSE',
        DOB: '3 g b - DOB: 16 Nov 2015',
        breeder: 'Sail From Seattle - Pacific Peace by Dynaformer Breeder: Moutonshoek',
        weight: '60kg',
        jockeySilks: 'R1-14'
    },
    {
        name: '8 WINTERS WAYS',
        DOB: '5 ch g - DOB: 01.10.2013',
        breeder: 'HORSE CHESTNUT - Fenella ( Kitalpha ) Breeder: ALDORA STUD',
        weight: '60kg',
        jockeySilks: 'R1-3'
    },
    {
        name: '9 PILOTHOUSE',
        DOB: '3 g b - DOB: 16 Nov 2015',
        breeder: 'Sail From Seattle - Pacific Peace by Dynaformer Breeder: Moutonshoek',
        weight: '60kg',
        jockeySilks: 'R1-9'
    },
    {
        name: '10 WINTERS WAYS',
        DOB: '5 ch g - DOB: 01.10.2013',
        breeder: 'HORSE CHESTNUT - Fenella ( Kitalpha ) Breeder: ALDORA STUD',
        weight: '60kg',
        jockeySilks: 'R1-8'
    }
];